import { Select } from "@radix-ui/themes";

import { useAppSelector } from "@/app/appStore";
import {
  selectGondolaDropdownValue,
  selectSelectedGondola,
  selectSelectedOrder,
  selectSelectedCameraMode,
} from "@/entities/annotation";

import { CAMERA_MODES } from "@/entities/annotation/model/consts";
import useCameraHandlers from "../hooks/useCameraHandlers";

const CameraModeSelector = () => {
  const selectedOrder = useAppSelector(selectSelectedOrder);
  const selectedGondola = useAppSelector(selectSelectedGondola);
  const gondolaDropdownValue = useAppSelector(selectGondolaDropdownValue);
  const selectedCameraMode = useAppSelector(selectSelectedCameraMode);
  const { handleCameraModeSelect } = useCameraHandlers();

  return (
    <Select.Root
      value={selectedCameraMode}
      size="1"
      disabled={
        !selectedOrder ||
        !selectedGondola ||
        (gondolaDropdownValue?.id === -1 &&
          selectedCameraMode === CAMERA_MODES.ALL)
      }
      onValueChange={handleCameraModeSelect}
    >
      <Select.Trigger />
      <Select.Content>
        <Select.Item value={CAMERA_MODES.ALL}>All cameras</Select.Item>
        <Select.Item value={CAMERA_MODES.HAND}>
          Hand tracking camera
        </Select.Item>
        <Select.Item value={CAMERA_MODES.SHELF}>
          Shelf tracking camera
        </Select.Item>
      </Select.Content>
    </Select.Root>
  );
};

export default CameraModeSelector;
